import React from "react";
import { useReveal } from "../hooks/useScroll";
import Pool from "../components/Pool";

/* This section exists instead of a wall of percentages. Every line here is a
   property of the product that can be checked by opening it, rather than a
   result claimed on somebody else's behalf. If a figure ever appears on this
   site it will have a client's name attached and their permission behind it. */
const FACTS = [
  {
    k: "Consent",
    t: "Asked before anything is collected",
    p: "The guest agrees on the first screen, and the age gate is enforced on the server as well as in the browser, because a public form can be replayed with any values you like.",
  },
  {
    k: "Ownership",
    t: "The record is yours, not rented",
    p: "First-party from the moment it is created. No cookie pool, no bought audience, no third party sitting between you and the person who answered.",
  },
  {
    k: "Personal data",
    t: "Masked by default, revealed deliberately",
    p: "Guests read as references until someone senior enough turns it on, which is audit-logged and times out on its own. Exports are anonymised unless you make a second, separate choice.",
  },
  {
    k: "Residency",
    t: "Johannesburg, on Johannesburg time",
    p: "The database and everything a guest or a staff member waits on run in africa-south1. Every date on every screen renders in South African time regardless of whose laptop is open.",
  },
  {
    k: "Access",
    t: "An authenticator app, or you do not get in",
    p: "Mandatory second factor on every account, idle sign-out, brute-force throttling that cannot be routed around from the browser, and an append-only audit log.",
  },
  {
    k: "Clients",
    t: "A dashboard without an account",
    p: "Scoped to what was agreed, expiring on a date you set, passcode optional, revocable, view-counted. It can be narrowed after it goes out. It can never be quietly widened.",
  },
  {
    k: "Written insight",
    t: "The model is never asked to do the maths",
    p: "It receives finished figures and writes prose about them. It never sees a name, an email, or a free-text answer, and a page load never spends a call.",
  },
  {
    k: "Getting data out",
    t: "PDF, Excel, and links that stay live",
    p: "Plus scheduled digests that carry the report itself rather than a button somebody opens later. There is no public API yet, and we would rather say so than imply one.",
  },
];

export default function Facts() {
  const ref = useReveal();
  return (
    <section className="sec sec--pad" id="truth" ref={ref}>
      <div className="shell">
        <div className="truth__head">
          <div className="rv">
            <span className="eyebrow">Straight answers</span>
            <p className="pull" style={{ marginTop: 22 }}>
              There are no performance figures on this site.{" "}
              <em>
                We have not run your campaign yet, and a number we invented would
                be the least useful thing here.
              </em>
            </p>
            <p className="body" style={{ marginTop: 22, maxWidth: "46ch" }}>
              So here is the other kind of answer: the things that are true about
              how it works, which you can check by opening it. Starting with the
              one nobody believes until they press it.
            </p>
          </div>

          <div className="rv" style={{ "--d": "90ms" }}>
            <Pool />
          </div>
        </div>

        <div className="facts rv" style={{ marginTop: 64 }}>
          {FACTS.map((f) => (
            <div className="fact" key={f.k}>
              <span className="fact__k">{f.k}</span>
              <h4 style={{ marginTop: 11 }}>{f.t}</h4>
              <p>{f.p}</p>
            </div>
          ))}
        </div>

        <p className="rv body" style={{ marginTop: 30, maxWidth: "60ch", color: "var(--fg-3)" }}>
          When we do quote results, they will be one named campaign, with the
          client's permission, and the dashboard behind them will be the same one
          you are looking at.
        </p>
      </div>
    </section>
  );
}
